import { paymentScheduleService } from '@afterpaytouch/portal-api/consumer/paymentSchedule'

export const {
  useGetPaymentScheduleQuery,
  useGetOverduePaymentsQuery,
  useInitiateInstallmentPaymentMutation,
  useConfirmPayNowMutation,
  endpoints: { initiateInstallmentPayment, confirmPayNow, getOverduePayments },
} = paymentScheduleService
